// FileUpload.js
import React, { useState ,useEffect} from 'react';
import axios from 'axios';
const FileUpload = (props) => {
  const [files, setFiles] = useState([]);
  const [uploadId, setuploadId] = useState("");
// const FileUpload = ({props, uploadID, mode, resume}) => {
//   const [files, setFiles] = useState([]);
//   const [uploadId, setuploadId] = useState('');

  // useEffect(() => {
  //   if(mode === 'edit' && uploadID) {
  //     setuploadId(uploadID);
  //   }
  //   if(mode === 'edit' && resume) {
  //     setFiles(resume);
  //   }
  // })

  // 파일 선택 시 즉시 업로드
  const handleFileChange = async (event) => {
    const selectedFiles = Array.from(event.target.files);
    const newFiles = [...files, ...selectedFiles];

    const formData = new FormData();
    for (const file of newFiles) {
      try {
        // AJAX를 통한 파일 업로드 요청
         
        
        formData.append("multipartFiles", file);
        console.log(file.uploadId);
        console.log('시작222233111');
        
      } catch (error) {
        // 파일 업로드 실패 시 에러 처리
         
      }
    }
    try {
      console.log('시작');
      console.log(newFiles);
      formData.append("uploadId", uploadId);
      await axios.post('/uploadFilestemp', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((res) => { 
        setuploadId(res.data);   
        
        props.ValueChange(res.data);
        props.uploadId=uploadId;
      })
      .catch((err) => {console.error(err)}); 
      
    } catch (error) {
      
    }
  
     

    setFiles(newFiles);

    console.log(newFiles)
    console.log(newFiles.uploadId)
    console.log(files.uploadId)
    console.log(props.uploadId)
    console.log('끝단')
  };
/////////////////////////////////////////ㅇㅇ
  // 파일 삭제
  const handleFileRemove = async (fileToRemove) => {
    try {
      setFiles(files.filter((file) => file !== fileToRemove));
      //  console.log(fileToRemove);
       const formData = new FormData();
      for (const file of files.filter((file) => file !== fileToRemove)) {
        try {
          // AJAX를 통한 파일 업로드 요청
           
          
          formData.append("multipartFiles", file);
          
        } catch (error) {
          // 파일 업로드 실패 시 에러 처리
           
        }
      }
      try {
        console.log(files.filter((file) => file !== fileToRemove));
        formData.append("uploadId", uploadId);
        await axios.post('/uploadFilestemp', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then((res) => { 
          console.log('시작2222222222');
          setuploadId(res.data);   
          
          props.ValueChange(res.data);
          props.uploadId=uploadId;
          console.log(uploadId);
        
          // uploadId=res.data;
        })
        .catch((err) => {console.error(err)}); 
        
      } catch (error) {
        
      }
    } catch (error) {
       
    }
  };
  // 전체 파일 리스트 삭제
  const handleClearList = () => {
     

     
    
    const formData = new FormData();
    setFiles([]);
    // 선택된 각 파일에 대해 순회하며 업로드 진행
     
    console.log(formData);
    formData.append("uploadId", uploadId);
    axios.post('/deleteFiles', formData,
      {headers:{
          'Content-Type': 'multipart/form-data'
      }}
      ).then((res) => { 
        console.log('시작1111111111'); 
        setuploadId(res.data);   
        
        props.ValueChange(res.data); 
        props.uploadId=uploadId; 
        console.log(uploadId); 
      
        // uploadId=res.data;
      })
      .catch((err) => {console.error(err)}); 
  };

  return (
    <div style={{ marginTop: '20px', padding: '20px', border: '1px solid #ccc', borderRadius: '8px', width: '999px', margin: '0 auto' }}>
      {/* <h2>첨부파일</h2> */}
      <input type="file" id="inputtag"  onChange={handleFileChange} style={{ display: 'none' }}   multiple />
      <label for="inputtag" 
             style={{padding: '8px 16px',
                     background: '#828282',
                     color: '#fff',
                     border: 'none',
                     borderRadius: '4px',
                     cursor: 'pointer',}}> 파일 업로드</label>
      <ul style={{ marginTop: '10px', padding: '0', listStyle:'',  maxHeight: '200px', overflow: 'auto' , display:'Block'}}>
        {files.map((file, index) => (
            <li key={index}
                style={{
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '5px',
                padding: '5px 10px',
                borderBottom: '1px solid #ddd',
              }}
          >
            {file.name}
            {/* {mode !== 'edit' &&  */}
              <button
              onClick={() => handleFileRemove(file)}
              style={{
                marginLeft: '10px',
                padding: '4px 8px',
                background: '#828282',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              삭제
            </button>
          {/* }  */}

          </li>
        ))}
      </ul>
      {files.length > 0 && (
        <button
          onClick={handleClearList}
          style={{
            marginTop: '10px',
            padding: '8px 16px',
            background: '#828282',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'block',
          }}
        >
          리스트 초기화
        </button>
      )}
      
    </div>
  );
};

export default FileUpload;